// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ListDepartmentsQueryVariables = Types.Exact<{
  pageNumber: Types.InputMaybe<Types.Scalars['Int']['input']>;
  pageSize: Types.InputMaybe<Types.Scalars['Int']['input']>;
  enabled: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  keyword: Types.InputMaybe<Types.Scalars['String']['input']>;
  hasEmployees?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  excludeIds: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
  businessUnitId: Types.InputMaybe<Types.Scalars['ID']['input']>;
  companyId: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;

export type ListDepartmentsQuery = { __typename?: 'Query' } & {
  listDepartments: { __typename?: 'ListDepartments' } & Pick<Types.ListDepartments, 'totalCount'> & {
      items: Array<
        { __typename?: 'Department' } & Pick<
          Types.Department,
          'id' | 'name' | 'enabled' | 'createdAt' | 'updatedAt'
        > & {
            definitions: Array<
              { __typename?: 'DefinitionItem' } & Pick<Types.DefinitionItem, 'languageCode' | 'displayName' | 'content'>
            >;
          }
      >;
    };
};

export const ListDepartmentsDocument = /*#__PURE__*/ gql`
    query listDepartments($pageNumber: Int, $pageSize: Int, $enabled: Boolean, $keyword: String, $hasEmployees: Boolean = null, $excludeIds: [ID!], $businessUnitId: ID, $companyId: ID) {
  listDepartments(
    filter: {pageNumber: $pageNumber, pageSize: $pageSize, enabled: $enabled, keyword: $keyword, hasEmployees: $hasEmployees, excludeIds: $excludeIds, businessUnitId: $businessUnitId, companyId: $companyId}
  ) {
    items {
      id
      name
      enabled
      createdAt
      updatedAt
      definitions {
        languageCode
        displayName
        content
      }
    }
    totalCount
  }
}
    `;

/**
 * __useListDepartmentsQuery__
 *
 * To run a query within a React component, call `useListDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDepartmentsQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *      enabled: // value for 'enabled'
 *      keyword: // value for 'keyword'
 *      hasEmployees: // value for 'hasEmployees'
 *      excludeIds: // value for 'excludeIds'
 *      businessUnitId: // value for 'businessUnitId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useListDepartmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListDepartmentsQuery, ListDepartmentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListDepartmentsQuery, ListDepartmentsQueryVariables>(ListDepartmentsDocument, options);
}
export function useListDepartmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListDepartmentsQuery, ListDepartmentsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListDepartmentsQuery, ListDepartmentsQueryVariables>(ListDepartmentsDocument, options);
}
// @ts-expect-error
export function useListDepartmentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListDepartmentsQuery, ListDepartmentsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListDepartmentsQuery, ListDepartmentsQueryVariables>;
export function useListDepartmentsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListDepartmentsQuery, ListDepartmentsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListDepartmentsQuery | undefined, ListDepartmentsQueryVariables>;
export function useListDepartmentsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListDepartmentsQuery, ListDepartmentsQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListDepartmentsQuery, ListDepartmentsQueryVariables>(ListDepartmentsDocument, options);
}
export type ListDepartmentsQueryHookResult = ReturnType<typeof useListDepartmentsQuery>;
export type ListDepartmentsLazyQueryHookResult = ReturnType<typeof useListDepartmentsLazyQuery>;
export type ListDepartmentsSuspenseQueryHookResult = ReturnType<typeof useListDepartmentsSuspenseQuery>;
